export default __webpack_public_path__ + "static/media/smartCryptoLogo.8bafd5c2.png";